import React from 'react'

import UnknownProductDetail from '@shared/unknown_products/UnknownProductDetail'
import { useLoaderData } from 'react-router-dom'

import { unknownProductService } from '@services/admin/unknownProductService'
import productService from '@services/admin/productService'

export default function AdminUnknownProductShow() {
  const unknownProduct = useLoaderData()

  return (
    <UnknownProductDetail
      unknownProduct={unknownProduct}
      role="admin"
      unknownProductService={unknownProductService}
      productService={productService}
    />
  )
}
